import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const appStoreState = namespace('appStore');
@Component({})
export default class PopupSubmitReportSuccessComponent extends Vue {
  language = localStorage.getItem('currentLanguage') !== undefined ? localStorage.getItem('currentLanguage') : 'en';

  @appStoreState.Getter
  public getIsShowPopupSubmitReportSuccess!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupSubmitReportSuccess!: (payload: boolean) => void;

  handleCloseModal() {
    this.setIsShowPopupSubmitReportSuccess(false);
  }
}
